import type { SessionsTour } from '@carboncopyco/data';
import type { ReactElement } from 'react';
import { useDashboardProps } from '../../DashboardContext';
import { RowWrapper } from '../../RowWrapper';

type TourRowWrapperProps = {
  children: ReactElement;
  item: SessionsTour;
};

export const TourRowWrapper = ({ children, item }: TourRowWrapperProps) => {
  const { goToTour } = useDashboardProps();

  return (
    <RowWrapper
      onRowClick={() =>
        goToTour(Number(item?.asset.assetId), item?.asset.workspaceId)
      }
      size="lg"
      separator
    >
      {children}
    </RowWrapper>
  );
};
